import { Component } from '@angular/core';

@Component({
  selector: 'app-rpost-loginredirect',
  templateUrl: './rpost-loginredirect.component.html',
  styleUrls: ['./rpost-loginredirect.component.css']
})
export class RpostLoginredirectComponent {

  ngOnInit(): void {
  
    $('#divProcessingCommon').css("display","none");
    
    
  }
}
